import { Component, Input, ViewChild } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { SamwinUserStatusState } from 'src/app/store/samwin/samwin-user-status/samwin-user-status.state';
import { UserStatusInfoRemoteDto } from 'src/generated/signalR/user-status-info-remote-dto';
import { UserStatusDropdownComponent } from '../user-status/user-status-dropdown/user-status-dropdown.component';

@Component({
   selector: 'samweb-avatar-status-selection',
   templateUrl: './avatar-status-selection.component.html',
   styleUrls: ['./avatar-status-selection.component.scss'],
})
export class AvatarStatusSelectionComponent {
   @ViewChild('userStatusDropdown', { static: false }) userStatusDropdown: UserStatusDropdownComponent;

   @Select(SamwinUserStatusState.currentStatusInfo)
   public currentUserStatusInfo$: Observable<UserStatusInfoRemoteDto>;

   public showTooltip = false;

   @Input()
   public userId: number = null;

   public onAvatarClick() {
      this.userStatusDropdown.toggleDropdown();
   }
}
